import { formatDateRange } from "@chriscdn/format-date";
import type { Album } from "~/api";

const albumDateRangeFormat = (album: Album) =>
  formatDateRange(album.startDate, album.endDate, { locale: "en-GB" });

export { albumDateRangeFormat };
